import React from 'react';

import cx from 'classnames';
import { Sparkle } from 'phosphor-react';

import Text from 'components/shared/Typography/Text';

import s from './AILoaderWrapper.module.css';

const AnimatedDots = () => {
  return (
    <div className={s.dotsLoader}>
      <Text type="brandon" size="large" isStrong className={s.dot}>
        .
      </Text>
      <Text type="brandon" size="large" isStrong className={s.dot}>
        .
      </Text>
      <Text type="brandon" size="large" isStrong className={s.dot}>
        .
      </Text>
    </div>
  );
};

export const AILoaderWrapper = ({ children, isLoading }: { children: React.ReactNode; isLoading: boolean }) => {
  return (
    <div className={cx(s.wrapper, isLoading && s.wrapperWithLoader)}>
      {children}

      {isLoading && (
        <div className={s.blurWrapper}>
          <div className={s.loader}>
            <div>
              <Sparkle size={36} />
            </div>
            <div className={s.titleWrapper}>
              <Text type="brandon" size="large" isStrong className={s.title}>
                AI is writing
              </Text>
              <AnimatedDots />
            </div>
            <div>
              <Text type="brandon">Please wait as this may take a few moments.</Text>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
